import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import useSeo from '@/hooks/useSeo';
import { featuredList, heroCase, rankedList } from '@/mocks/cases';
import HomeHero from '@/pages/home/components/HomeHero';
import HotSection from '@/pages/home/components/HotSection';
import RankSection from '@/pages/home/components/RankSection';
import ArchiveSection from '@/pages/home/components/ArchiveSection';
import RumorSection from '@/pages/home/components/RumorSection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import FaqSection, { faqItems } from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';

const SITE = 'https://eogtxkn.cn';

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    const el = document.getElementById(hash.slice(1));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, [hash]);

  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '瓜田追踪',
        alternateName: '网红爆料后续追踪站',
        url: SITE,
        description:
          '专注网红爆料的后续进展，持续整理事件反转、辟谣动态与当事人回应，用时间线还原完整来龙去脉。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${SITE}/?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '瓜田追踪',
        url: SITE,
        email: 'hello@guatian-zhui.example',
        description: '聚焦内容生态的爆料后续追踪与核实团队。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: '瓜田追踪 · 网红爆料后续追踪',
        url: SITE,
        inLanguage: 'zh-CN',
        description:
          '汇总直播带货、内容版权、公益争议、品牌联动与剧情炒作等类型的追踪档案与最新进展。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqItems.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.a,
          },
        })),
      },
    ],
    [],
  );

  useSeo({
    title: '瓜田追踪 · 网红爆料后续追踪｜反转·辟谣·当事人回应',
    description:
      '瓜田追踪专注网红爆料的后续进展，持续整理事件反转、辟谣动态与当事人回应，用时间线还原完整来龙去脉，帮你理性看待每一条热点爆料。',
    keywords: '网红爆料,爆料后续,事件反转,辟谣澄清,当事人回应,热点追踪',
    canonical: `${SITE}/`,
    jsonLd,
  });

  return (
    <SiteLayout>
      <HomeHero hero={heroCase} />
      <HotSection items={featuredList} />
      <RankSection items={rankedList} />
      <ArchiveSection />
      <RumorSection />
      <TimelineSection />
      <FaqSection />
      <AboutSection />
    </SiteLayout>
  );
};

export default Home;